import { Component, ElementRef, Inject, HostListener, OnDestroy, OnInit, Renderer2, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';

import { ListEventService } from '../list-item/list-event.service';
import { ListActivatedService } from '../list-item/list-activated.service';

@Component({
  selector: 'ui-list-sliding',
  templateUrl: './list-sliding.component.html'
})
export class ListSlidingComponent implements OnInit, OnDestroy {
  @HostBinding('style.transitionDuration') transitionDuration: string;
  @HostBinding('style.transform') transform: string;

  private subs: Array<Subscription> = [];
  private distanceX: number = 0;
  private refs: Array<ElementRef> = [];
  private isFocus = false;

  constructor(private listEventService: ListEventService,
              private listActivatedService: ListActivatedService,
              private renderer: Renderer2) {
  }

  ngOnInit() {
    // æ¿å°å½å list-item ç»ä»¶ä¸ï¼ææç list-options ç»ä»¶ï¼ä»¥ä¾¿å¨åå¨æ¶ï¼è®¡ç® dom çå®½åº¦
    this.subs.push(this.listEventService.listOptions.subscribe((elementRef: ElementRef) => {
      this.refs.push(elementRef);
    }));
    // è®¢ééä¸­äºä»¶ï¼å¹¶å¤æ­ç¨æ·æä½ç list-sliding æ¯ä¸æ¯èªèº«ï¼å¦æä¸æ¯èªèº«ï¼åä¿®æ¹èªèº«ç¸åºæ ·å¼
    this.subs.push(this.listActivatedService.activatedComponent.subscribe(() => {
      if (!this.isFocus) {
        this.distanceX = 0;
        this.transitionDuration = '';
        this.transform = 'translateX(0px)';
      }
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(item => {
      item.unsubscribe();
    });
  }

  @HostListener('touchstart', ['$event'])
  touchstart(event: any) {
    this.isFocus = true;
    const touchPoint = event.touches[0];

    const startX = touchPoint.pageX;
    const startY = touchPoint.pageY;

    const oldDistanceX = this.distanceX;
    const startTime = Date.now();

    let maxDistance = 0;

    this.refs.forEach((item: ElementRef) => {
      maxDistance += item.nativeElement.offsetWidth;
    });

    let isClick = true;
    let isScroll = true;

    // è®¾ç½®å½ååç´ ç css å¨ç»æ¶é´ä¸º0ï¼é²æ­¢æè¿æ»æ
    this.transitionDuration = '0s';

    let unBindTouchEndFn: () => void;
    let unBindTouchCancelFn: () => void;

    const unBindTouchMoveFn = this.renderer.listen('document', 'touchmove', (moveEvent: any) => {
      isClick = false;
      const newTouchPoint = moveEvent.touches[0];

      const moveX = newTouchPoint.pageX;
      const moveY = newTouchPoint.pageY;

      // å½ç¨æ·è§¦æ¸ççºµåè·ç¦»å¤§äºæ¨ªåè·ç¦»ï¼è½å¿½ç¥æ­¤æ¬¡åå¨ï¼ä¸è§¦ååå·¦æ»å¨çå¨ä½
      if (isScroll && Math.abs(moveX - startX) < Math.abs(moveY - startY)) {
        unBindTouchCancelFn();
        unBindTouchMoveFn();
        unBindTouchEndFn();
        return;
      }

      // è®¡ç®åå·¦æ»å¨çè·ç¦»
      this.distanceX = moveX - startX + oldDistanceX;
      if (this.distanceX > 0) {
        this.distanceX = 0;
      }
      if (this.distanceX < -maxDistance) {
        this.distanceX = -maxDistance;
      }

      // è®¾ç½®ç¸åºæ ·å¼ï¼å¹¶é»æ­¢äºä»¶åæ³¡åé»è®¤äºä»¶
      this.transform = `translateX(${this.distanceX}px)`;
      isScroll = false;
      moveEvent.stopPropagation();
      return false;
    });

    const touchEndFn = () => {
      this.isFocus = false;
      const endTime = Date.now();
      const distance = oldDistanceX - this.distanceX;
      // å½ç¨æ·è§¦æ¸å®æåï¼æ¶é´å°äº 100msï¼å¹¶ä¸è·ç¦»å¤§äº20ï¼åè®¤ä¸ºæ¯æ¯æ§è§¦æ¸
      if (endTime - startTime < 100 && Math.abs(distance) > 20) {
        this.distanceX = distance < 0 ? 0 : -maxDistance;
      } else {
        // å¦åæ 50% åºååå·¦è¿æ¯åå³
        this.distanceX = this.distanceX > maxDistance / -2 ? 0 : -maxDistance;
      }
      this.transitionDuration = '';
      this.transform = `translateX(${this.distanceX}px)`;
      unBindTouchCancelFn();
      unBindTouchMoveFn();
      unBindTouchEndFn();
    };

    unBindTouchEndFn = this.renderer.listen('document', 'touchend', touchEndFn);
    unBindTouchCancelFn = this.renderer.listen('document', 'touchcancel', touchEndFn);

    setTimeout(() => {
      if (isClick) {
        unBindTouchCancelFn();
        unBindTouchMoveFn();
        unBindTouchEndFn();
      }
    }, 100);
  }
}
